export const facilities = {
	"Augusta Correctional Center": "1927",
    "Baskerville Correctional Center": "1879",
    "Bland Correctional Center": "1912",
    "Brunswick Work Center": "2150",
    "Buckingham Correctional Center": "1928",
    "Caroline Correctional Unit": "1877",
    "Central Virginia Correctional Unit": "1888",
    "Coffeewood Correctional Center": "1929",
    "Cold Springs Correctional Unit": "1885",
    "Deep Meadow Correctional Center": "1922",
    "Deerfield Correctional Center": "1948",
    "Deerfield Mens Work Center": "2153",
    "Deerfield Women's Work Center": "2503",
    "Detainer Unit": "6136",
    "Dillwyn Correctional Center": "1941",
    "Fluvanna Correctional Center": "1951",
    "Green Rock Correctional Center": "2587",
    "Greensville Correctional Center": "1932",
    "Greensville Work Center": "1908",
    "Halifax Correctional Unit": "1897",
    "Haynesville Correctional Center": "1942",
    "Haynesville Correctional Unit 17": "1892",
    "Indian Creek Correctional Center": "1943",
    "Interstate Compact-Facility": "6129",
    "James River Work Center": "1909",
    "Keen Mountain Correctional Center": "1940",
    "Lawrenceville Correctional Center": "1950",
    "Lunenburg Correctional Center": "1931",
    "Marion Correctional Treatment Center": "1961",
    "Mecklenburg Correctional Center": "1923",
    "Nottoway Correctional Center": "1930",
    "Nottoway Work Center": "1910",
    "Patrick Henry Correctional Unit": "1902",
    "Pocahontas State Correctional Center": "2586",
    "Powhatan County Jail": "2100",
    "Powhatan Reception And Classification Ctr": "2181",
    "Red Onion State Prison": "1945",
    "River North Correctional Center": "6264",
    "Rustburg Correctional Unit": "1884",
    "St. Brides Correctional Center": "1947",
    "Sussex I State Prison": "1938",
    "Sussex II State Prison": "1939",
    "Virginia Correctional Center For Women": "1916",
    "Wallens Ridge State Prison": "1946",
    "Wise Correctional Unit": "1893"
}


// WEBPACK FOOTER //
// ./src/utils/facilitiesList.js